import { useAuthenticated } from '@gettactic/hooks';
import { getCustomParkingVerbiage } from '@gettactic/helpers';

export const useCustomParkingVerbiageOnMapBuilder = () => {
  // separate to avoid compiler error
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  const orgSlug = authenticatedUser?.slug ?? '';
  return getCustomParkingVerbiage(orgSlug);
};
